<template>
  <v-card
    border
    class="pa-5 no-focus"
    @click="showDetails = !showDetails"
  >
    <div class="d-flex align-center">
      <div class="d-flex">
        <v-icon
          class="static-gradient-background rounded-circle pa-7 my-2"
          color="white"
          size="x-large"
          style="font-size: 40px"
        >
          mdi-email-fast
        </v-icon>
        <div class="d-flex flex-column align-center justify-center px-4">
          <span class="text-h6 text-grey font-weight-light text-no-wrap">{{
            $t('acquisition-booster.title')
          }}</span>
          <v-btn
            v-if="totalInvitationsCount > 0 && $vuetify.display.mdAndUp"
            color="primary"
            @click.stop="goToLeadsList"
          >
            {{ $t('buttons.acquisition-booster.cta') }}
          </v-btn>
        </div>
      </div>

      <div
        v-if="totalInvitationsCount > 0"
        class="pb-0 text-h5 font-weight-medium d-flex w-full"
      >
        <v-row v-if="$vuetify.display.mdAndUp">
          <v-col
            :cols="12"
            class="d-flex align-center"
          >
            <InvitationStatistics
              :total-invitations-count="totalInvitationsCount"
              :interacted-invitations-count="interactedInvitationsCount"
            />
          </v-col>
        </v-row>

        <v-spacer v-if="!$vuetify.display.mdAndUp" />
        <v-btn
          v-if="hasMultipleAcquisitionBoosterInvitations"
          icon
          size="small"
          variant="text"
          color="black"
          width="28"
          height="28"
          style="font-size: 16px"
        >
          <v-icon color="primary">
            {{ showDetails ? 'mdi-chevron-up-circle-outline' : 'mdi-chevron-down-circle-outline' }}
          </v-icon>
        </v-btn>
      </div>

      <InitialAcquisitionBooster
        v-if="totalInvitationsCount <= 0 && $vuetify.display.mdAndUp"
        class="ml-8"
      />
    </div>

    <InitialAcquisitionBooster
      v-if="totalInvitationsCount <= 0 && $vuetify.display.smAndDown"
      class="mt-8"
    />

    <div v-if="totalInvitationsCount > 0">
      <div
        v-if="$vuetify.display.smAndDown"
        class="d-flex flex-column mt-6"
      >
        <InvitationStatistics
          :total-invitations-count="totalInvitationsCount"
          :interacted-invitations-count="interactedInvitationsCount"
        />
        <v-btn
          color="primary"
          class="mt-6"
          @click.stop="goToLeadsList"
        >
          {{ $t('buttons.acquisition-booster.cta') }}
        </v-btn>
      </div>

      <v-expand-transition v-if="hasMultipleAcquisitionBoosterInvitations">
        <div
          v-show="showDetails"
          class="mt-5"
        >
          <v-divider />

          <v-card-text class="px-0 pb-0 mx-0 mb-0 mt-2">
            <v-row v-if="$vuetify.display.smAndUp">
              <v-col
                sm="5"
                class="py-0 text-center text-grey"
              >
                <span class="mr-1 text-subtitle-1 text-grey text--darken-3" />
              </v-col>
              <v-col
                sm="3"
                class="py-0 d-flex justify-center text-grey"
                :class="{ 'd-flex justify-space-between w-full': $vuetify.display.xs }"
              >
                <span>{{ $t('labels.acquisition-booster.invitations') }}</span>
              </v-col>
              <v-col
                sm="3"
                class="py-0 d-flex justify-center text-grey"
                :class="{ 'd-flex justify-space-between w-full': $vuetify.display.xs }"
              >
                <span>{{ $t('labels.acquisition-booster.interactions') }}</span>
              </v-col>
            </v-row>
            <v-row
              v-for="{
                landingpageSlug,
                landingpageName,
                total,
                conversions,
              } of invitationsPerLandingpage"
              :key="landingpageSlug"
              :class="{ 'd-flex flex-column': $vuetify.display.xs }"
            >
              <v-col
                sm="5"
                class="py-0 text-grey"
              >
                <span class="mr-1 text-subtitle-1 text-grey text--darken-3">{{
                  landingpageName
                }}</span>
              </v-col>
              <v-col
                sm="3"
                class="py-0 d-flex justify-center text-grey"
                :class="{ 'justify-space-between w-full': $vuetify.display.xs }"
              >
                <span v-if="$vuetify.display.xs">{{
                  $t('labels.acquisition-booster.invitations')
                }}</span>
                <span class="mr-1 text-subtitle-1 text-grey text--darken-3">{{ total }}</span>
              </v-col>
              <v-col
                sm="3"
                class="py-0 d-flex justify-center text-grey"
                :class="{ 'justify-space-between w-full': $vuetify.display.xs }"
              >
                <span v-if="$vuetify.display.xs">{{
                  $t('labels.acquisition-booster.interactions')
                }}</span>
                <span class="mr-1 text-subtitle-1 text-grey text--darken-3">{{ conversions }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-expand-transition>
    </div>
  </v-card>
</template>

<script>
import InitialAcquisitionBooster from './InitialAcquisitionBooster.vue'
import InvitationStatistics from './InvitationStatistics.vue'

export default {
  components: {
    InvitationStatistics,
    InitialAcquisitionBooster,
  },
  props: {
    invitationStatisticsForCompany: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDetails: false,
    }
  },
  computed: {
    invitationsPerLandingpage() {
      return this.invitationStatisticsForCompany?.invitationsPerLandingpage
    },
    hasMultipleAcquisitionBoosterInvitations() {
      return this.invitationsPerLandingpage?.length > 1
    },
    totalInvitationsCount() {
      return this.invitationStatisticsForCompany?.total
    },
    interactedInvitationsCount() {
      return this.invitationStatisticsForCompany?.conversions
    },
  },
  methods: {
    goToLeadsList() {
      this.$router.push({
        path: '/leads/list',
        query: {
          toolOpen: 'acquisition',
        },
      })
    },
  },
}
</script>
<style scoped>
.no-focus:focus:before {
  background: none;
}
</style>
